import { z } from "zod";

import { imageFormatSchema } from "api/schemas/imageCollectionApiSchema";
import { sourceSchema } from "api/schemas/knowledgeApiSchema";
import { nullToUndefined } from "api/utils";

const baseTopicSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.string(),
  mentions: z.number(),
  image_url: nullToUndefined(z.string()),
  images: nullToUndefined(imageFormatSchema),
});

const stakeholderSchema = baseTopicSchema.extend({
  is_added: z.boolean(),
  subtitle: nullToUndefined(z.string()),
  uri: nullToUndefined(z.string()),
  type: nullToUndefined(z.string()),
});

const relatedTopicSchema = baseTopicSchema.extend({
  name_EN: z.string(),
});

export const emergingThemeSchema = z.object({
  id: z.string(),
  timestamp: z.number(),
  knowledge_count: z.number(),
  time: z.number(),
  title: z.string(),
  image_url: z.string(),
  description: z.string(),
  is_bookmarked: z.boolean(),
  images: imageFormatSchema,
  days_count: z.number(),
  sources: z.array(sourceSchema),
  related_topics: z.array(relatedTopicSchema),
  stakeholders: z.array(stakeholderSchema),
  sources_count: z.number(),
  type: nullToUndefined(z.string()),
  time_bookmarked: nullToUndefined(z.number()),
});

export type EmergingTheme = z.infer<typeof emergingThemeSchema>;
